<template>
  <div>
    <v-tabs v-model="tab" active-class="tab-active" background-color="transparent">
      <v-tab class="tab-default" v-for="day in Object.keys(weekdays)" :key="day">{{ day | scheduleDay }}</v-tab>
    </v-tabs>

    <v-card :flat="$vuetify.breakpoint.smAndDown" elevation="0" outlined>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="day in Object.keys(weekdays)" :key="day">
          <div class="pa-2 px-4" v-for="(busSchedule, index) in weekdays[day]" :key="busSchedule.key">
            <div cols="5" class="title my-2">{{ busTimelines[busSchedule.key].title }}</div>

            <v-row class="my-2">
              <v-col cols="12">
                <v-row>
                  <v-col cols="1" class="vertical-line"></v-col>
                  <v-col cols="11" class="pt-0">
                    <BusScheduleDestination type="start" :direction="busSchedule.direction" class="mb-n4 mb-4" />
                    <BusScheduleList
                      class="full-width mt-4"
                      :busStopList="busSchedule.busStops"
                      @on-add-student="addStudent"
                      @on-remove-student="updateStudents"
                      @on-update-bus-stop="updateBusStop"
                      @on-delete-bus-stop="deleteBusStop"
                      @on-edit-student-default-absent="onEditDefaultAbsent"
                    />
                    <BusScheduleDestination type="end" :direction="busSchedule.direction" class="mt-4 mb-n4" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <div class="text-end">
              <v-btn @click="() => addBusStop(busSchedule, index)" small color="primary" outlined>Thêm điểm dừng</v-btn>
            </div>
            <v-divider v-if="index !== 3" class="mt-4" />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
    <BusStopNewDialog :state="addBusStopDialog" :busSchedule="busSchedule" />
    <BusStopUpdateDialog :state="updateBusStopDialog" :busStop="selectedBusStop" />
    <BusStopAddStudentDialog :state="addStudentDialog" :busStop="selectedBusStop" />
    <BusStopUpdateStudentDialog :state="updateStudentDialog" :busStop="selectedBusStop" />
    <BusStopDefaultAbsentDialog ref="edit-default-absent-dialog" />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BusStopNewDialog from '@/modules/bus/BusStopNewDialog.vue'
import BusStopUpdateDialog from '@/modules/bus/BusStopUpdateDialog.vue'
import BusStopAddStudentDialog from '@/modules/bus/BusStopAddStudentDialog.vue'
import BusStopUpdateStudentDialog from '@/modules/bus/BusStopUpdateStudentDialog.vue'
import BusScheduleDestination from './BusSchedule/BusScheduleDestination.vue'
import BusScheduleList from './BusSchedule/BusScheduleList.vue'
import BusStopDefaultAbsentDialog from './BusStopDefaultAbsentDialog.vue'

export default {
  components: {
    BusStopNewDialog,
    BusStopUpdateDialog,
    BusStopAddStudentDialog,
    BusStopUpdateStudentDialog,
    BusScheduleDestination,
    BusScheduleList,
    BusStopDefaultAbsentDialog,
  },
  data() {
    return {
      tab: null,
      addBusStopDialog: false,
      updateBusStopDialog: false,
      addStudentDialog: false,
      updateStudentDialog: false,
      busSchedule: {},
      selectedBusStop: {},
    }
  },
  computed: {
    ...mapGetters('constant', ['busTimelines']),
    ...mapGetters('busDetail', ['weekdays']),
  },
  methods: {
    ...mapActions('busDetail', ['removeBusStop']),
    addBusStop(data, index) {
      this.busSchedule = { ...data, index }
      this.addBusStopDialog = !this.addBusStopDialog
    },
    deleteBusStop(busStop) {
      this.$dialog.confirm({
        title: 'Xóa điểm dừng',
        text: `Bạn có Chắc Chắn muốn xóa điểm dừng ${busStop.address} ? Thao tác xóa này không thể hoàn tác. Xác nhận xóa ${busStop.address}?`,
        okText: 'OK',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          this.$loading.active = true
          await this.removeBusStop(busStop)
          this.$loading.active = false
        },
      })
    },
    updateBusStop(busStop) {
      this.selectedBusStop = busStop
      this.updateBusStopDialog = !this.updateBusStopDialog
    },

    addStudent(busStop) {
      this.selectedBusStop = busStop
      this.addStudentDialog = !this.addStudentDialog
    },
    updateStudents(busStop) {
      this.selectedBusStop = busStop
      this.updateStudentDialog = !this.updateStudentDialog
    },
    onEditDefaultAbsent(data) {
      this.$refs['edit-default-absent-dialog'].openDialog(data)
    },
  },
}
</script>

<style scoped>
.vertical-line {
  border-right: 1px solid;
  transform: translate(22px, 0px);
}
</style>
